// @flow

import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {Table, TableHeaderCell, TableCell} from '../../core/Table/Table';

type RolesEntry = {|
  name: string,
  id: string,
|};

type Props = {|
  roles: Array<RolesEntry>,
  children: React.Node,
|};

export const RoleIdTable = ({roles}: Props) => {
  if (!roles) {
    return null;
  }

  return (
    <Table type="striped">
      <thead>
        <tr>
          <TableHeaderCell>
            <FormattedMessage
              id="docsApp.components.RoleIdTable.dashboardRoleHeader"
              defaultMessage="Dashboard role"
            />
          </TableHeaderCell>
          <TableHeaderCell>
            <FormattedMessage
              id="docsApp.components.RoleIdTable.attirbuteRoleHeader"
              defaultMessage="Attribute statement role id"
            />
          </TableHeaderCell>
        </tr>
      </thead>
      <tbody>
        {roles.map((entry) => (
          <tr>
            <TableCell>{entry.name}</TableCell>
            <TableCell>{entry.id}</TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
